/**
 * Bound one already-started wait. This never starts requests, retries work or
 * schedules itself again; the workspace's sole timeout exception is here.
 */
export function withDeadline<T>(work: Promise<T>, fallback: T, milliseconds = 1200): Promise<T> {
  return new Promise(resolve => {
    const finish = (value: T) => { window.clearTimeout(timer); resolve(value); };
    const timer = window.setTimeout(() => finish(fallback), milliseconds);
    work.then(finish, () => finish(fallback));
  });
}
